// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2890":"a80b52aa","4180":"420ebad0","4535":"c83a1896"}[chunkId] + ".chunk.css";
};